import { get, post, del, put as update } from "helpers/api_helper";

const getRequest = async () => {
  return await get("/api/Company");
};

export const companyService = {
  getRequest,
};
